import React from 'react';
import styles from './HomeTeamName.module.scss';

const HomeTeamName = ({ name }) => {
    return <h4 className={styles.teamName}>{name}</h4>;
};

export default HomeTeamName;
